import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from '@/router/authGuard';
import HomeView from '@/views/HomeView.vue';
import HomeworkView from '@/views/Homework/HomeworkView.vue';
import HomeworkDetailView from '@/views/Homework/HomeworkDetailView.vue';
import HomeworkCreateView from '@/views/Homework/HomeworkCreateView.vue';
import HomeworkEditView from '@/views/Homework/HomeworkEditView.vue';
import SubtaskDetailView from '@/views/Subtask/SubtaskDetailView.vue';
import SubtaskCreateView from '@/views/Subtask/SubtaskCreateView.vue';
import SubtaskEditView from '@/views/Subtask/SubtaskEditView.vue';
import LoginView from '@/views/LoginView.vue';
import GlobalFileView from '@/views/GlobalFile/GlobalFileView.vue';
import EvaluationView from '@/views/Evaluation/EvaluationView.vue';
import EcaliationDetailView from '@/views/Evaluation/EvaluationDetailView.vue';
import CourseActionsView from '@/views/CourseActionsView.vue';
import ManageSemestersView from '@/views/ManageSemestersView.vue';
import CourseMaterialsView from '@/views/CourseMaterials/CourseMaterialsView.vue';
import StudentCourseMaterialsView from '@/views/CourseMaterials/StudentCourseMaterialsView.vue';
import HelpView from '@/views/HelpView.vue';
import QueueView from '@/views/QueueView.vue';
import CompetitionView from '@/views/Competition/CompetitionView.vue';
import CompetitionEditView from '@/views/Competition/CompetitionEditView.vue';
import PreparingNewSemesterView from '@/views/PreparingNewSemesterView.vue';
import AskAIView from '@/views/AskAIView.vue';

const routes = [
  {
    path: '/',
    component: HomeView,
    meta: {
      title: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/preparing-new-semester',
    component: PreparingNewSemesterView,
    meta: {
      title: 'Preparing New Semester',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    component: LoginView,
    meta: {
      title: 'Login',
      requiresAuth: false
    }
  },
  {
    path: '/homeworks',
    component: HomeworkView,
    meta: {
      title: 'Homework List',
      requiresAuth: true
    }
  },
  {
    path: '/homework/:id',
    component: HomeworkDetailView,
    meta: {
      title: 'Homework Detail',
      requiresAuth: true
    }
  },
  {
    path: '/homework/create',
    component: HomeworkCreateView,
    meta: {
      title: 'Create Homework',
      requiresAuth: true
    }
  },
  {
    path: '/homework/edit/:id',
    component: HomeworkEditView,
    meta: {
      title: 'Edit Homework',
      requiresAuth: true
    }
  },
  {
    path: '/subtask/:id',
    component: SubtaskDetailView,
    meta: {
      title: 'Task Detail',
      requiresAuth: true
    }
  },
  {
    path: '/subtask/create/:homework_id',
    name: 'SubtaskCreateView',
    component: SubtaskCreateView,
    meta: {
      title: 'Create Task',
      requiresAuth: true
    }
  },
  {
    path: '/subtask/edit/:id',
    component: SubtaskEditView,
    meta: {
      title: 'Edit Task',
      requiresAuth: true
    }
  },
  {
    path: '/global_files',
    component: GlobalFileView,
    meta: {
      title: 'Global Files',
      requiresAuth: true
    }
  },
  {
    path: '/evaluations',
    component: EvaluationView,
    meta: {
      title: 'Evaluation',
      requiresAuth: true
    }
  },
  {
    path: '/evaluation/:id',
    component: EcaliationDetailView,
    meta: {
      title: 'Evaluation Detail',
      requiresAuth: true
    }
  },
  {
    path: '/queue',
    component: QueueView,
    meta: {
      title: 'Queue Management',
      requiresAuth: true
    }
  },
  {
    path: '/course_actions',
    component: CourseActionsView,
    meta: {
      title: 'Course Actions',
      requiresAuth: true
    }
  },
  {
    path: '/semesters',
    component: ManageSemestersView,
    meta: {
      title: 'Manage Semesters',
      requiresAuth: true
    }
  },
  {
    path: '/course_materials',
    component: CourseMaterialsView,
    meta: {
      title: 'Course Materials',
      requiresAuth: true
    }
  },
  {
    path: '/materials',
    component: StudentCourseMaterialsView,
    meta: {
      title: 'Course Materials',
      requiresAuth: true
    }
  },
  {
    path: '/help',
    component: HelpView,
    meta: {
      title: 'Help',
      requiresAuth: true
    }
  },
  {
    path: '/competition',
    component: CompetitionView,
    meta: {
      title: 'Competition',
      requiresAuth: true
    }
  },
  {
    path: '/competition/edit',
    component: CompetitionEditView,
    meta: {
      title: 'Edit Competition',
      requiresAuth: true
    }
  },
  {
    path: '/ask-ai',
    name: 'AskAI',
    component: AskAIView,
    meta: {
      title: 'Ask AI',
      requiresAuth: true
    }
  },
  {
    path: '/teacher-ask-ai',
    name: 'TeacherAskAI',
    component: () => import('@/views/TeacherAskAIView.vue'),
    meta: {
      title: 'Ask AI',
      requiresAuth: true
    }
  }
];

// Set base dynamically, based on:k if it is running on university server or not
const base = process.env.VUE_APP_UNI_SERVER === 'True' ? '/pa036-hw/' : '/';

const router = createRouter({
  history: createWebHistory(base),
  routes,
});

router.beforeEach(authGuard);

export default router;
